import React from 'react';
import ProjectContainer from '../../containers/projectmng/ProjectContainer';

const ProjectDetailPage = () => {
  const pageUrl="/projectmng";
  return <ProjectContainer pageUrl={pageUrl}/>
};

export default ProjectDetailPage;
